import React, { memo } from "react";
import { Box, Center, Divider, Text } from "@chakra-ui/react";
import colors from "app/colors";

const MessageUnreadLine = () => (
  <Box w="full">
    <Divider
      borderColor={colors.yellowDark}
      borderWidth="1px"
      opacity={1}
      top="9px"
      position="relative"
    />
    <Center w="full">
      <Text
        fontSize={12}
        zIndex={1}
        backgroundColor={colors.yellowDark}
        color={colors.white}
        rounded="full"
        px={4}
        w={150}
        h={18}
        textAlign="center"
      >
        Unread
      </Text>
    </Center>
  </Box>
);

export default memo(MessageUnreadLine);
